module.exports = __webpack_public_path__ + "img/circle-quarter.c9dc7255.svg";